import React from 'react';
import clsx from 'clsx';
var UnMemoizedCustomNotification = function (props) {
    var active = props.active, children = props.children, className = props.className, type = props.type;
    if (!active)
        return null;
    return (React.createElement("div", { "aria-live": 'polite', className: clsx("str-chat__custom-notification notification-".concat(type), "str-chat__notification", "str-chat-react__notification", className), "data-testid": 'custom-notification' }, children));
};
export var CustomNotification = React.memo(UnMemoizedCustomNotification);
